import { topicsAction } from './topic-slice'
import { toCApi } from '../utils'
import { throwApiError } from '../components/lms-shared/store/error-handling-actions'
import { initMessages } from './messages-actions'
import { ActivityTypeEnum } from '../components/lms-shared/models/ActivityTypeEnum'

export const fetchTopicsData = (studyGroupId, application, uiData) => {

  return async (dispatch, getState) => {
    const state = getState();
    const texts = state.translate?.texts
    const studyGroup = state.topics.studyGroup
    dispatch(topicsAction.initTopics({ lessonByTopic: null, topics: null }))

    const lessonesListType = uiData[application]?.lessonesListType;

    if (studyGroupId && lessonesListType) {
      const dataApi = {
        courseId: null,
        studyGroupId: studyGroupId,
        active: null,
        visible: true,
        ignoreDateRange: true,
        includeAssessments: true,
      }

      toCApi.toCFilterRangePost({ toCRangeFilter: dataApi }, (error, resdata, response) => {
        if (error) {
          dispatch(throwApiError({ userMessage: texts.MessageTitleTocFilterRange, error: error, statusCode: response?.statusCode, message: "toCFilterRangePost " + error.message, level: 1, component: "topic-actions", line: 27 }))
        }
        else {
          let indexOnMap;
          let lessonIndex = 1
          let topicsListTemp = [[], [], []];
          let allTopicsList = { [lessonesListType[0]]: [], [lessonesListType[1]]: [], [lessonesListType[2]]: [] };

          if (uiData[application].changeDisplayOrder === true) {
            const contest = response.body[1];
            response.body[1] = response.body[2];
            response.body[2] = contest;
          }

          function createtopicsList(child, typeLessons, index, lengthParant, indexChild) {
            let flag = false
            if (child.isLesson == true) {
              if (indexChild > lengthParant - 5) {
                if (!uiData.aiCourses?.list?.includes(studyGroup.courseId))
                  child.indexOnMap = indexOnMap++;
                else
                  child.indexOnMap = indexChild;
              }
              child.index = lessonIndex++;
              if (!topicsListTemp[typeLessons][index])
                topicsListTemp[typeLessons][index] = []
              const finalAssessment = child.assessments?.find(a => ActivityTypeEnum[a.activityType] == ActivityTypeEnum.Final);
              if (finalAssessment?.dueDate) {
                child.isLate = new Date(finalAssessment.dueDate) < new Date(finalAssessment.submission?.submittedDate ? finalAssessment.submission.submittedDate : new Date())
              }
              child.lessonType = lessonesListType[typeLessons]
              topicsListTemp[typeLessons][index].push(child)
              flag = true
              child.ClientDate = new Date()
            }
            else {
              if (child.children.length > 0 && flag === false)
                child.children.map((l, indexChild) => { createtopicsList(l, typeLessons, index, child.children.length, indexChild + 1) })
            }
          }
          response.body && response.body.map((y, index) => {
            indexOnMap = 1
            return y.children.map((y2, index2) => createtopicsList(y2, index, index2, response.body.length, 0))
          })


          response.body.map((z, index) =>
            z.children.map((z1, index1) =>
              allTopicsList[lessonesListType[index]]?.push({ lessons: topicsListTemp[index][index1], tag: { id: z1.id, name: z1.name } })))

          dispatch(topicsAction.initTopics({ lessonByTopic: allTopicsList, topics: response.body }))
        }
      })
    }
  }
}

export const setStudyGroup = (studyGroupId, navigate, MessageCB, uiData, location) => {
  return async (dispatch, getState) => {
    const state = getState();
    if (!studyGroupId) {
      dispatch(topicsAction.initStudyGroup({ studyGroup: {}, lessonByTopic: null, topics: null }))
    }
    else {
      const studyGroup = { ...state?.curriculums?.curriculums?.find(c => c.id === studyGroupId) }
      if (Object.keys(studyGroup).length === 0) {
        MessageCB()
      }
      else {
        if (!studyGroup.isParticipant) {
          navigate(`${state?.application.homeUrl}/connect/${studyGroup.courseId}/${studyGroup.id}`, { state: { url: `/student${location.pathname}` } })
        }
        if (studyGroup.courseId !== state.topics?.studyGroup?.courseId) {
          dispatch(initMessages(studyGroup.courseId, uiData))
        }
        dispatch(topicsAction.initStudyGroup({ studyGroup: studyGroup, lessonByTopic: null, topics: null }))
      }
    }

  }
}